import { getMaskFromName, ValidatedInput } from '@finbeat/react-toolkit';
import ClientChangeModal from 'components/Workplaces/Clients/ClientChangeModal';
import { PaymentToClientInfo } from 'models/api/paymentsToClients';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

const ClientTab = () => {
    const { t } = useTranslation();
    const [clientOpen, setClientOpen] = useState(false);
    const { watch } = useFormContext<PaymentToClientInfo>();

    const clientId = watch('clientId');
    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="firstName"
                            label={t('BackOfficeFirstName')}
                            disabled
                        />
                    </Col>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="middleName"
                            label={t('BackOfficeMiddleName')}
                            disabled
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="lastName"
                            label={t('BackOfficeLastName')}
                            disabled
                        />
                    </Col>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="secondLastName"
                            label={t('BackOfficeSecondLastName')}
                            disabled
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="email"
                            label={t('BackOfficeEmail')}
                            disabled
                        />
                    </Col>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="phoneNumber"
                            label={t('BackOfficePhoneNumber')}
                            maskProps={{
                                mask: getMaskFromName('Uzbekistan'),
                            }}
                            disabled
                        />
                    </Col>
                </Row>
            </Container>
            {clientOpen && (
                <ClientChangeModal isOpen={clientOpen} toggle={setClientOpen} id={clientId} />
            )}
        </>
    );
};

export default ClientTab;
